.AdCreator {
  padding: 12px;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  background: var(--primitives-colors-neutral-980);
  border-radius: 26px;

  .creatorImage {
    position: relative;
    aspect-ratio: 160 / 150;
    overflow: hidden;

    .withSnapFeed & {
      aspect-ratio: 1 / 1;
      width: 100%;
      flex: 1;
    }

    img {
      width: 100%;
      height: 100%;
      border-radius: var(--semantics-radius-20) var(--semantics-radius-20) 0 0;
      object-fit: cover;
    }
  }

  .badgeIcon {
    position: absolute;
    top: 4px;
    right: 4px;
  }

  .creatorTitleWrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .creatorTitle {
    font: var(--font-body-md-semibold);
    margin: 11px 0;
    white-space: nowrap;
    width: 100%;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0 4px;
  }

  .creatorLink {
    --btn-icon-size: var(--semantics-icon-xs);

    padding: 0;

    svg {
      path {
        stroke: var(--primitives-colors-neutral-0);
      }
    }
  }
}